import React from "react";
import Modal from 'react-modal';
import ScrollAnimation from 'react-animate-on-scroll';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTiktok, FaInfoCircle} from "react-icons/fa";
import { IoMdCloseCircleOutline } from 'react-icons/io';
import 'animate.css';
import DOMPurify from "dompurify";

// СоцСети
const SocialIcons = ({ fbLink, instLink, linkedinLink, tiktokLink, openModal }) => {
    const socialLinks = [
        { link: fbLink, icon: <FaFacebookF className="w-4 h-4 text-[#8f78be]" /> },
        { link: instLink, icon: <FaInstagram className="w-4 h-4 text-[#8f78be]" /> },
        { link: linkedinLink, icon: <FaLinkedinIn className="w-4 h-4 text-[#8f78be]" /> },
        { link: tiktokLink, icon: <FaTiktok className=" w-4 h-4 text-[#8f78be]" /> },
    ];

    return (
        <div className="absolute -left-[18px] -top-[10px] rounded-full z-[20] space-y-2 
            bg-[#f7eae8] p-[3px] border-[3px] border-white box-content text-center "
        >
            {socialLinks.map((social, index) =>
                social.link ? (
                    <a
                        key={index}
                        href={social.link}
                        className="block bg-gray-200 rounded-full p-2 hover:bg-gray-300 transition "
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {social.icon}
                    </a>
                ) : null
            )}
            <button
                type="button"
                className="block bg-gray-200 rounded-full p-2 hover:bg-gray-300 transition"
                onClick={openModal}
            >
                <FaInfoCircle className="w-4 h-4 text-[#8f78be]" />
            </button>
        </div>
    );
};

// Модалка Спикера
const SpeakerModal = ({ speaker, isOpen, closeModal }) => {
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={closeModal}
            ariaHideApp={false}
            className="modal-container fixed top-0 left-0 right-0 bottom-0 bg-black bg-opacity-50 flex justify-center items-center"
        >
            <button
                onClick={closeModal}
                className="absolute top-0 right-0 p-4 text-red-800 hover:text-red-600 focus:outline-none"
            >
                <IoMdCloseCircleOutline className="text-red-800 text-4xl" />
            </button>

            <div className="bg-white w-full max-w-4xl p-6 shadow-lg shadow-[#001D53] m-9 overflow-hidden">
                <div className="overflow-y-auto h-[80vh] max-h-max">
                    <div className="flex flex-wrap flex-col md:flex-row items-center md:items-start">
                        <div className="mb-4 md:mb-0 md:w-4/12 overflow-hidden bg-[#f7eae8]">
                            <img
                                src={speaker.acf.sm_image}
                                alt={speaker.post_title}
                                className="w-full h-auto"
                            />
                        </div>
                        <div className="md:w-4/6 md:pl-6 w-full sm:w-auto">
                            <div className="mb-4 pb-4 border-b-2">
                                <h3 className="text-3xl font-semibold text-center md:text-left mb-3">{speaker.post_title}</h3>
                                {speaker.acf.logo && (
                                    <img
                                        src={speaker.acf.logo}
                                        alt="Logo"
                                        className="object-contain w-16 mb-4 m-auto md:ml-0"
                                        style={{"width": speaker.acf.logo_mw + "px"}}
                                    />
                                )}
                                <p className="text-sm text-center md:text-left text-gray-600">{speaker.acf.position}</p>
                            </div>

                        </div>
                        <div className="speacer-popup-info w-full mt-4"
                             dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(speaker.acf.info, {sanitize: true})}}/>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

// Карточка Спикера
const SpeakerCard = ({speaker}) => {
    const [modalIsOpen, setIsOpen] = React.useState(false);

    const openModal = () => setIsOpen(true);
    const closeModal = () => setIsOpen(false);

    return (
        <div className="bg-white shadow-xl flex flex-col items-center relative speacercard">
            <div className="overflow-hidden speacercardinfo">
                <img
                    className="mx-auto w-full h-auto transition duration-[400ms wp-post-image]"
                    src={speaker.acf.sm_image}
                    alt={speaker.post_title}
                />
            </div>
            <div className="relative p-4 pt-0">
                <div className="relative -mt-4 mb-3 z-[9] w-full max-w-max bg-white p-2 shadow-lg mx-auto">
                    {speaker.acf.logo && (
                        <img
                            src={speaker.acf.logo}
                            alt="Logo"
                            className="object-contain w-16"
                            style={{"width": speaker.acf.logo_mw + "px"}}
                        />
                    )}
                </div>
                <h3 className="text-lg mb-2 font-semibold text-center">{speaker.post_title}</h3>
                <p className="text-sm text-center text-gray-600">{speaker.acf.position}</p>
            </div>
            <button onClick={openModal} className="absolute w-full h-full z-[10]"></button>

            <SpeakerModal speaker={speaker} isOpen={modalIsOpen} closeModal={closeModal} className="ssds" />

            <SocialIcons
                fbLink={speaker.acf.fb_link}
                instLink={speaker.acf.inst_link}
                linkedinLink={speaker.acf.linkedin_link}
                tiktokLink={speaker.acf.tiktok_link}
                openModal={openModal}
            />
        </div>
    );
};

// Основной компонент для отображения спикеров
const EventSpeakersBase = ({ speacersData }) => {
    return (
        <>
            {speacersData && speacersData.length > 0 ? (
                <section className="pb-20 pt-20 bg-[#f7eae8]" id="speacers">
                    <div className="container px-4 w-[90%] sm:w-full mx-auto">
                        <div className="text-center w-full">
                            <ScrollAnimation animateIn="animate__fadeInUp">
                                <h2 className="text-4xl mb-9 uppercase">Спікери</h2>
                            </ScrollAnimation>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                            {speacersData.map((speaker, index) => (
                                <SpeakerCard key={index} speaker={speaker} />
                            ))}
                        </div>
                    </div>
                </section>
            ) : null}
        </>
    );
};


export default EventSpeakersBase;
